// El aviso que ve un club al aceptar un torneo de un deporte que no tiene habilitado.
// La base manda los NOMBRES (deportes_faltantes, 20261002); aqui solo se arma la frase.
const unir = (nombres) =>
  nombres.length === 1
    ? nombres[0]
    : `${nombres.slice(0, -1).join(', ')} y ${nombres[nombres.length - 1]}`

export const textoDeportesFaltantes = (nombres) => {
  const lista = (Array.isArray(nombres) ? nombres : []).filter(Boolean)
  if (lista.length === 0) return null
  if (lista.length === 1) {
    return `Este torneo incluye ${lista[0]} y tu club no lo tiene habilitado. Puedes aceptar, pero para inscribir grupos pide al administrador de MYKLUBB que lo active.`
  }
  return `Este torneo incluye ${unir(lista)}, y tu club no los tiene habilitados. Puedes aceptar, pero para inscribir grupos pide al administrador de MYKLUBB que los active.`
}
